export default {
  /*按钮*/
  bt: {
    search: "搜索",
    query: "查询",
    operation: "操作",
    add: "新增",
    edit: "修改",
    delete: "删除",
    down: "下载",
    export: "导出",
    upload: "上传"
  },
  /*公用字段或工具函数字段*/
  common: {
    startTime: "开始时间",
    endTime: "结束时间",
    creator: "创建人",
    updater: "更新人",
    createTime: "创建时间",
    updateTime: "更新时间",
    phone: "手机号",
    name: "姓名",
    email: "邮箱",
    idNumber: "身份证号码",
    status: "状态",
    remark: "备注",
  },
  active: {
    activeNo: "活动编号",
    activeName: "活动名称",
    activeTime: "活动时间",
    openTime: "开户时间",
    status: "活动状态",
    androidChannel: "android渠道",
    iosChannel: "ios渠道",
    review: "审核",
    disable: "禁用",
    enable: "启用",
    bonusDesc: "奖励描述",
    url: "链接地址",
    activeDescribe: "活动描述",
    userList: "黑名单",
    joinCustomerStatus: "参与用户状态",
    alwaysShow: "游客是否显示红包",
    limitType: "限时类型",
    limitDays: "限时天数",
    taskContent: "任务与奖励",
    name: "渠道名称",
    pkg: "渠道包名",
    os: "系统类型",
    pleaseInput: "请填充 ",
    valid: "数据检验",
    enter: "确定",
    startTimeError: "活动开始时间不能小于当前时间",
    taskContentComplete: "活动开始时间不能小于当前时间",
    taskContentRepeat: "请勿设置重复任务",
    customerNo: "账号",
    task: "任务",
    startTime: "活动开始时间",
    endTime: "活动结束时间",
    customerCreateStartTime: "开户开始时间",
    customerCreateEndTime: "开户结束时间",
    customerActivatedStartTime: "激活开始时间",
    customerActivatedEndTime: "激活结束时间",
    chineseName: "客户姓名",
    task1: "开通真实账户",
    task3: "完善资料",
    task4: "首次入金",
    task5: "累计交易1手外汇",
    task6: "累计交易1手商品",
    task7: "累计交易1手指数",
    task8: "累计交易1手数字货币",
    task9: "交易下单",
    task10: "累计交易1手股票",
    customerCreateTime: "用户开户时间",
    customerActivatedTime: "用户激活时间",
    customerStatus: "用户状态",
    amount: "奖励金额(美元)",
    amountCny: "奖励金额(越南盾)",
    selectTask: "请选择任务",
    taskTitle: "任务标题",
    taskDescribe: "任务描述",
    rewardValue: "赠金额度($)",
    orderNo: "发放流水",
    taskName: "任务名称",
    platform: "平台",
    taskTitleVn: "任务标题(越南)",
    taskDescribeVn:"任务描述(越南)",
    bonusDescVn: "奖励描述(越南)",
    activeDescribeVn: "活动描述(越南)",
    luckyTime:"抽奖时间",
    luckyStartTime:"抽奖开始时间",
    luckyEndTime:"抽奖结束时间",
    copy:"复制"
  },
  pushMsg: {
    parent: "所属业务",
    appName: "应用名称",
    status: "状态",
    remark: "备注",
    appKey: "appKey",
    appSecret: "appSecret",
    createTime: "创建时间",
    updateTime: "更新时间",
    updater: "更新人",
    env: "推送环境",
    prd: "生产环境",
    dev: "开发环境",
    check: "切换环境",
    isStop: "确定暂停?",
    isEnable: "确定启用?",
    fabu: "+发布消息公告",
    releaseStatus: "同步到",
    msgTitle: "消息标题",
    business: "所属业务",
    platform: "推送平台",
    msgLanguage: "语言",
    pushTime: "推送时间",
    pushConfig: "推送配置",
    type: "消息类型",
    pushStatus: "推送状态",
    msgPlatform: "应用平台",
    channel: "渠道",
    targetUsers: "目标用户",
    users: "目标用户1",
    businessId: "所属业务",
    updateDate: "修改时间",
    fabuDate: "发布时间",
    createBy:"创建人",
    push: "同步",
    pushMode: "推送方式",
    msgRemark: "消息描述",
    msgContent: "消息内容",
    fabudao: "发布到",
    fabuson: "发布人",
    yewu: "业务",
    createDate: "发布时间",
    contentType:"内容类型",
    msgUrl:"推送url",
    symbol:"产品",
  },
  task:{
    id:"活动编号",
    activityName:"活动名称",
    typeName:"类型名称",
    startDate:"开始时间",
    endDate:"结束时间",
    assignCount:"指定参与人数",
    androidChannel:"Android渠道",
    iosChannel:"IOS渠道",
    auditStatus:"状态",
    realName:"创建者",
    createDate:"创建时间",
    updateDate:"更新时间",
    activityTitleEn:"英文活动标题",
    activityTitleVn:"越南活动标题",
    activityDescEn:"英文任务描述",
    activityDescVn:"越南文任务描述",
    bankName:"任务类型",
    userLevel:"参与用户",
    rewardDateType:"奖励物品",
    rewardAmount:"奖励额度",
    effectiveEndDay:"有效期",
    jumpType:"跳转类型",
    jumpWeb:"跳转链接",
    jumpApp:"跳转页面",
    taskTime:"活动时间",
    copy:"复制",
    audit:"审核",
    noPass:"不通过",
    pass:"通过",
    notAudit:"未审核",
    blacklistImport:"黑名单导入",
    userAssign:"指定用户",
    detail:"详情",
    participateUser:"参与用户",
    granRecord:"发奖记录",
    blacklist:"黑名单",
    export:"导出",
    userExport:"活动参与用户导出",
    participationTotal:"参与用户数",
    awardUserTotal:"领奖用户数",
    acceptTheRate:"领奖率",
    reward:"可领取金额",
    getRewardAmount:"已领取金额",
    achieveStatus:"完成状态",
    min:"迷你",
    std:"标准",
    pla:"铂金",
    zer:"巴菲特",
    rewardDateType1:"赠金",
    jumpType1:"不跳转",
    jumpType2:"网页链接",
    jumpType3:"app页面",
    jumpAppOptins0:"行情-自选",
    jumpAppOptins1:"行情-外汇",
    jumpAppOptins2:"行情-商品",
    jumpAppOptins3:"行情-指数",
    jumpAppOptins4:"股票",
    jumpAppOptins6:"热门",
    jumpAppOptins8:"我-推荐有礼",
    jumpAppOptins9:"我-账户升级",
    jumpAppOptins10:"我-存款",
    choose:"请选择",
    hand:"手",
    taskList1:"交易产品",
    taskList2:"开仓手数",
    taskList3:"平仓手数",
    classList2:"外汇",
    classList4:"商品",
    classList5:"指数",
    classList7:"股票",
    all:"全选",
    errorMessage1:"最多只能添加3个",
    auditStatus0:"待审核",
    auditStatus1:"已启用",
    auditStatus2:"已停用",
    auditStatus3:"已结束",
    userStatus1:"冻结",
    userStatus2:"销户",
    userStatus3:"已激活",
    userStatus4:"未激活",
    userStatus5:"黑名单",
    activationStatus1:"未完成",
    activationStatus2:"未领取",
    activationStatus3:"已领取",
    activationStatus21:"已完成待领取",
    customerNo:"交易账户",
    userName:"姓名",
    phone:"手机号码",
    openAccountDate:"开户时间",
    activationTime:"激活时间",
    userStatus:"用户状态",
    getAchieveStatus:"领取状态",
    participateDate:"参与时间",
    achieveDate:"完成时间",
    awardDate:"领奖时间",
    orderOn:"发放流水",
    taskList4:"单笔入金金额",
    taskList5:"净入金金额",
    taskList6:"入金方式",
    us:"美元"
  }
, luckyRedPacket: {
    create: "+创建活动",
    name: "活动名称",
    name1: "活动时间",
    status: "状态",
    createName: "创建者",
    createTime: "创建时间",
    id: "活动id",
    startTime: '活动开始时间',
    endTime: '活动结束时间',
    createDate: "创建时间",
    updateDate: "更新时间",
    sum: "参与用户数",
    describe: "活动描述",
    info: "详情",
    copy: "复制",
    stop: "停用",
    shenPi:"审批",
    enable: "启用",
    black: "添加黑名单",
    addUser: "上传用户",
    get: "可获得",
    redPacket: "美元红包",
    condition: "获取条件",
    exchange: "兑换条件",
    get1: "天内",
    notIsEmp:"不能为空",
    textStatus:"是否审批该活动?",
    tipStatus:"提示",
    okStatus:"确定",
    offStatus:"取消",
    exchangeCount:"兑换用户数",
    exchangeRate:"兑换率",
    status1:"已启用",
    status2:"已停用",
    status3:"已结束",
    status4:"待审核",
    participationStatus1:"待发奖",
    participationStatus2:"发放成功",
    participationStatus3:"发放失败",
    participationStatus4:"扣回中",
    participationStatus5:"已扣回",
    participationStatus6:"未扣回",
    exchangeStatus1:"未获得",
    exchangeStatus2:"未兑换",
    exchangeStatus3:"已兑换",
    exchangeStatus4:"兑换失败",
    activation1:"已激活",
    activation2:"未激活",
    account:"账号",
    openTime:"开户时间",
    activationStatus:"激活状态",
    activationTime:"激活时间",
    participationStatus:"参与状态",
    participationTime:"参与时间",
    accountReal:"真实账号",
    accountName:"用户",
    realOpenTime:"真实开户时间",
    exchangeStatus:"兑换状态",
    redBonus:"红包金额(美元)",
    receivePrizeTime:"兑换时间",
    sendStatus:"发放状态",
  },
taskType:{
  typeName:"类型标题",
  typeStatus:"状态",
  creator:"创建者",
  createDate:"创建时间",
  updateDate:"更新时间",
  typeStatus0:"停用",
  typeStatus1:"启用",
  startDate:"开始时间",
  endDate:"结束时间",
  titleNameEn:"英文类型名称",
  titleNameVn:"越南文类型名称",
  typeDescEn:"英文描述",
  typeDescVn:"越南文描述"
},
  taskGolden:{
    goldenName:"名称",
    goldenAlias:"别名",
    goldenDesc:"说明",
    goldenStatus:"状态",
    creator:"创建者",
    createDate:"创建时间",
    updateDate:"更新时间",
    disable: "停用",
    enable: "启用",
  }
}
